import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StorageItem {
  id: string;
  consignmentNumber: string;
  volume: number;
}

export interface StorageLocation {
  id: string;
  name: string;
  warehouse: string;
  capacity: number;
  currentVolume: number;
  items: StorageItem[];
}

interface StorageState {
  locations: StorageLocation[];
  isSidebarOpen: boolean;
}

const initialState: StorageState = {
  isSidebarOpen: true,
  locations: [
    {
      id: 'brindisi',
      name: 'Brindisi',
      warehouse: 'UNHRD Warehouse 1',
      capacity: 5000,
      currentVolume: 3433,
      items: []
    },
    {
      id: 'san-vito',
      name: 'San Vito',
      warehouse: 'UNHRD Warehouse 2',
      capacity: 2000,
      currentVolume: 37,
      items: []
    },
    {
      id: 'pisa',
      name: 'Pisa',
      warehouse: 'TNT Warehouse',
      capacity: 1000,
      currentVolume: 191,
      items: []
    },
    {
      id: 'ancona',
      name: 'Ancona',
      warehouse: 'TNT Warehouse',
      capacity: 500,
      currentVolume: 7,
      items: []
    },
    {
      id: 'genova',
      name: 'Genova',
      warehouse: 'TNT Warehouse',
      capacity: 500,
      currentVolume: 37,
      items: []
    },
    {
      id: 'bologna',
      name: 'Bologna',
      warehouse: 'UPS Warehouse',
      capacity: 1000,
      currentVolume: 191,
      items: []
    },
    {
      id: 'milano',
      name: 'Milano',
      warehouse: 'UPS Warehouse',
      capacity: 500,
      currentVolume: 7,
      items: []
    }
  ]
};

const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    toggleStorageSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    addItemToStorage: (state, action: PayloadAction<{ locationId: string; item: StorageItem }>) => {
      const { locationId, item } = action.payload;
      const location = state.locations.find((l) => l.id === locationId);
      if (location) {
        location.items.push(item);
        location.currentVolume += item.volume;
      }
    },
    addItemsToStorage: (state, action: PayloadAction<{ locationId: string; items: StorageItem[] }>) => {
      const { locationId, items } = action.payload;
      const location = state.locations.find((l) => l.id === locationId);
      if (location) {
        location.items.push(...items);
        location.currentVolume += items.reduce((acc, item) => acc + item.volume, 0);
      }
    }
  }
});

export const { toggleStorageSidebar, addItemToStorage, addItemsToStorage } = storageSlice.actions;
/** TODO: move to entities later */
/** @deprecated */
export default storageSlice.reducer;
